.filters {
  display: grid;
  gap: 14px;
  margin: 0 0 28px;
}

.group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin: 0;
  padding: 0;
  border: 0;
}

.legend {
  margin-right: 6px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.24em;
  text-transform: uppercase;
  color: var(--label);
}

/* Pills like the tours search field: outlined, filled in the brand brown when on. */
.chip {
  min-height: 40px;
  padding: 0 16px;
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-pill);
  background: var(--card);
  color: var(--text);
  font: 500 14px var(--font-body);
  cursor: pointer;
}

.chip:hover {
  border-color: var(--primary);
}

.chip[aria-pressed='true'] {
  border-color: var(--primary);
  background: var(--primary);
  color: #ffffff;
}

.status {
  margin: 0 0 20px;
  font-size: 14px;
  color: var(--text-secondary);
}

/* Phones: each filter group is one row that scrolls sideways, edge to edge. */
@media (max-width: 767px) {
  .group {
    flex-wrap: nowrap;
    overflow-x: auto;
    margin: 0 calc(-1 * var(--gutter));
    padding: 0 var(--gutter);
    scrollbar-width: none;
  }

  .group::-webkit-scrollbar {
    display: none;
  }

  .legend,
  .chip {
    flex-shrink: 0;
    white-space: nowrap;
  }
}

/* The event page's highlights, set off from the description below. */
.highlights {
  margin-bottom: 24px;
}
